import loanFormModel from '../../form_models/loanFormModel';
import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';

const { systemPropertyOwnerPhone } = loanFormModel.formField;

export class PropertyOwnerPhoneNumberValidation implements ValidationSchema {
  public name: string = systemPropertyOwnerPhone.name;
  public label = '';
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;
}
export default new Validation(new PropertyOwnerPhoneNumberValidation());
